import axios from './index';
import {wxAuthBase} from "../utils/wxUtils";
import { Indicator,Toast } from 'mint-ui'
import store from '../store';
import router from "../router";

let dev = window.navigator.userAgent.toLocaleLowerCase().match(/MicroMessenger/i);
if (dev && dev[0] === 'micromessenger') {
    store.commit('CLIENT', 0);
} else {
    store.commit('CLIENT', 1);
}
var isloading = true
export const fetch = (options) => {
	var client = store.state.client
	if(options.data){
		if(options.data.mask == 0 ){
		}else{
			if(isloading){
				Indicator.open({ spinnerType: 'fading-circle', text: '加载中...' });
				isloading = false
			}
		}
	}else{
		if(isloading){
			Indicator.open({ spinnerType: 'fading-circle', text: '加载中...' });
			isloading = false
		}
	}
	return new Promise((resolve, reject) => {
		const instance = axios.create({});
		instance(options).then(response => {
			if(response.data.code === 4005) {
        let agreement = window.localStorage.getItem('read_agreement');
        if(agreement!=1){
          Indicator.close()
          router.push('/agreement')
        }else{
          // 未登录 || token过期
        Indicator.close()
				setTimeout(isloading = true,500)
        if(client == 0){
					// wxAuthBase(location.pathname + location.search);
          router.push('/login')
        }else{
          router.push('/login')
				}
        }
				
      }else if(response.data.code == 300 || response.data.code == 301){
        Indicator.close()
        setTimeout(isloading = true,500)
        if(response.data.msg){
          Toast({
            message:response.data.msg || 'null',
            duration:1500
          })
        }else{
          Toast({
            message:response.data.msg || 'null',
            duration:1500
          })
        }
			} else if(response.data.code == 4001 ){
        Indicator.close()
        if(response.data.msg){
          Toast({
            message:response.data.msg,
            duration:1500
          })
        }
			  setTimeout(function () {
			    router.push('/real')
        },1500)
      }
      else if(response.data.code == 4002 ){
        Indicator.close()
        setTimeout(isloading = true,500)
        if(response.data.msg){
          Toast({
            message:response.data.msg,
            duration:1500
          })
        }
        setTimeout(function () {
          router.push( '/change-payment?type=3')
        },1500)
      }
      else if(response.data.code == 4007 ){
        Indicator.close()
        setTimeout(isloading = true,500)
        if(response.data.msg){
          Toast({
            message:response.data.msg,
            duration:1500
          })
        }
        setTimeout(function () {
          router.push( '/payment')
        },1500)
      }
      else if(response.data.code == 4003 ){
        Indicator.close()
        setTimeout(isloading = true,500)
        if(response.data.msg){
          Toast({
            message:response.data.msg,
            duration:1500
          })
        }
        setTimeout(function () {
          router.push('/ratio-deal')
        },1500)
      }
      else if(response.data.code == 4006 ){
        Indicator.close()
        setTimeout(isloading = true,500)
        if(response.data.msg){
          Toast({
            message:response.data.msg,
            duration:1500
          })
        }
        setTimeout(function () {
          router.push('/add-address/0?pageType=add')
        },1000)
      }
      else if(response.data.code == 4004 ){
        Indicator.close()
        setTimeout(isloading = true,500)
        if(response.data.msg){
          Toast({
            message:response.data.msg,
            duration:1500
          })
        }
        setTimeout(function () {
          router.push('/mobile')
        },1500)
      }
			else {
        Indicator.close()
        setTimeout(isloading = true,800)
        resolve(response.data);
			}
		}).catch(error => {
        console.log('请求异常信息：'+error);
        setTimeout(isloading = true,500)
			  reject(error);
  			Indicator.close()
    })
	})
};

export default fetch;



// WEBPACK FOOTER //
// ./src/axios/fetch.js